import { applyMiddleware, createStore } from 'redux';
import reducers from '../reducers';
import thunk from 'redux-thunk';

export default graphqlClient => createStore(
	reducers(graphqlClient),
	{}, // Initial state
	applyMiddleware(graphqlClient.middleware(), thunk)
);



// WEBPACK FOOTER //
// ./src/assets/js/store/configure-production.js